import React, { useEffect, useRef, useState } from 'react';
import timeUp from '../../../assets/img/time-up-arro.svg';
import timeDown from '../../../assets/img/time-doun-arro.svg';
import ReactQuill from 'react-quill';
import { daysArray, selectLoader } from 'utils/Helpers';
import { useParams } from 'react-router-dom';
import APIServices from 'services/APIServices';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import { useAuth } from 'contexts/AuthContext';
import rightArrowIcon from '../../../assets/img/right-arrow.svg';
const UpdatesTab = ({
  isSetting = false,
  projectDetails,
  currentTab,
  isInternalProject,
  setCurrentTab,
  setCompletedTabs,
  setAutoUpdateSettings,
  autoUpdateSettings,
  defaultUpdates,
  updatesError = null,
  setUpdatesError
}) => {
  const { user } = useAuth();
  const { projectId: projectIdFromParams } = useParams();
  const submissionInProgressRef = useRef(false);
  const [projectId, setProjectId] = useState('');
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [isEditing, setEditing] = useState(false);
  const [error, setError] = useState(null);
  const [daysError, setDaysError] = useState('');
  const [timeZone, setTimeZone] = useState('');
  const [editingTimeField, setEditingTimeField] = useState(null); // 'hour' | 'minute' | null
  const isUpdatesBusy = loading || pageLoading;

  const [formData, setFormData] = useState({
    autoUpdate: false,
    selectedDays: ['Monday', 'Tuesday', 'Thursday'],
    hour: 12,
    minute: 0,
    period: 'AM',
    updateMessage: '',
    randomizeDelivery: false, // <-- Added this
    shareProgress: false,
    progressToShare: {
      milestones: 'none',
      tasks: 'none',
      subtasks: 'none',
      checklistItems: 'none'
    }
  });

  useEffect(() => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (userTimeZone) {
      setTimeZone(userTimeZone);
    }
    console.log("User's timezone:", userTimeZone);
  }, []);

  useEffect(() => {
    if (currentTab === 3) {
      if (projectIdFromParams) {
        setEditing(true);
        setProjectId(projectIdFromParams);
        fetchProjectUpdates(false);
      } else {
        fetchProjectUpdates(true);
      }
    }
  }, [projectIdFromParams, currentTab]);

  useEffect(() => {
    if (projectDetails) {
      setProjectId(projectDetails._id);
      if (!isInternalProject) {
        // fetchOrgUsers(projectDetails.organizationId);
      }
    } else if (projectIdFromParams) {
      setProjectId(projectIdFromParams);
      setEditing(true);
    }
  }, [projectDetails, projectIdFromParams]);

  useEffect(() => {
    if (updatesError !== null) {
      setDaysError(updatesError);
    }
  }, [updatesError]);

  useEffect(() => {
    if (setAutoUpdateSettings && autoUpdateSettings) {
      let updatedForm = {
        ...autoUpdateSettings,
        updateDays: formData.selectedDays,
        updateTime: `${formData.hour.toString().padStart(2, '0')}:${formData.minute.toString().padStart(2, '0')}`,
        updateMeridiem: formData.period,
        updateMessage: formData.updateMessage,
        timeZone: timeZone
      };
      setAutoUpdateSettings(updatedForm);
    }
  }, [formData]);

  useEffect(() => {
    if (defaultUpdates) {
      const [hourStr, minuteStr] = defaultUpdates.updateTime.split(':');
      const hour = parseInt(hourStr, 10);
      const minute = parseInt(minuteStr, 10);
      let updatedForm = {
        autoUpdate: defaultUpdates.autoUpdate,
        selectedDays: defaultUpdates.updateDays || [],
        hour: hour || 12,
        minute: minute || 0,
        period: defaultUpdates.updateMeridiem || 'AM',
        updateMessage: defaultUpdates.updateMessage || ''
      };
      setFormData(updatedForm);
      setAutoUpdateSettings(updatedForm);
    }
  }, [defaultUpdates]);
  const fetchProjectUpdates = async (isUser = false) => {
    setPageLoading(true);
    let endPoint = isUser ? 'userId=' + user._id : 'projectId=' + projectIdFromParams;
    try {
      let response = await APIServices.get(`/project-auto-update?${endPoint}`);
      console.log(response);
      if (response?.data?.updateMeridiem) {
        const result = response.data;

        // Split updateTime into hour and minute
        const [hourStr, minuteStr] = result?.updateTime.split(':');
        const hour = parseInt(hourStr, 10);
        const minute = parseInt(minuteStr, 10);

        // Set formData with values from the response
        setFormData({
          autoUpdate: result?.autoUpdate,
          selectedDays: result?.updateDays || [],
          hour: hour || 12,
          minute: minute || 0,
          period: result?.updateMeridiem || 'AM',
          updateMessage: result?.updateMessage || '',
          randomizeDelivery: result?.randomizeDelivery || false,
          shareProgress: !!result?.shareProgress,
          progressToShare: {
            milestones: result?.progressToShare?.milestones || 'none',
            tasks: result?.progressToShare?.tasks || 'none',
            subtasks: result?.progressToShare?.subtasks || 'none',
            checklistItems: result?.progressToShare?.checklistItems || 'none'
          }
        });
      } else if (response.data.message) {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error('Error fetching Project Updates:', error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const toggleDay = (dayValue) => {
    setFormData((prev) => {
      const isSelected = prev.selectedDays.includes(dayValue);
      return {
        ...prev,
        selectedDays: isSelected ? prev.selectedDays.filter((d) => d !== dayValue) : [...prev.selectedDays, dayValue]
      };
    });
    setDaysError('');
    if (setUpdatesError) {
      setUpdatesError('');
    }
  };

  const changeHour = (increment) => {
    setFormData((prev) => {
      let newHour = increment ? prev.hour + 1 : prev.hour - 1;
      if (newHour > 12) newHour = 1;
      if (newHour < 1) newHour = 12;
      return { ...prev, hour: newHour };
    });
  };

  const changeMinute = (increment) => {
    setFormData((prev) => {
      let newMinute = increment ? prev.minute + 1 : prev.minute - 1;
      if (newMinute >= 60) newMinute = 0;
      if (newMinute < 0) newMinute = 59;
      return { ...prev, minute: newMinute };
    });
  };

  const togglePeriod = () => {
    setFormData((prev) => ({
      ...prev,
      period: prev.period === 'AM' ? 'PM' : 'AM'
    }));
  };

  const toggleAutoUpdate = () => {
    setFormData((prev) => ({
      ...prev,
      autoUpdate: !prev.autoUpdate
    }));
  };

  const toggleShareProgress = () => {
    setFormData((prev) => {
      const shareProgress = !prev.shareProgress;

      return {
        ...prev,
        shareProgress,
        progressToShare: shareProgress
          ? {
              milestones: 'summary',
              tasks: 'summary',
              subtasks: 'summary',
              checklistItems: 'summary'
            }
          : prev.progressToShare
      };
    });
  };

  const setProgressLevel = (key, level) => {
    setFormData((prev) => {
      const progressToShare = { ...prev.progressToShare, [key]: level };
      const hasSelectedProgress = Object.values(progressToShare).some((progressLevel) => progressLevel !== 'none');

      return {
        ...prev,
        shareProgress: hasSelectedProgress ? prev.shareProgress : false,
        progressToShare
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submissionInProgressRef.current || pageLoading) {
      return;
    }

    // Validation: Require at least one day if autoUpdate is true
    if (formData?.autoUpdate && formData.selectedDays.length === 0) {
      setDaysError('Please select at least one update day.');
      return;
    }
    const endpoint = isEditing ? `/project-auto-update/${projectId}` : '/project-auto-update';
    submissionInProgressRef.current = true;
    setLoading(true);
    let payload = {
      projectId,
      timeZone,
      autoUpdate: formData?.autoUpdate,
      updateDays: formData?.selectedDays,
      updateTime: `${formData.hour.toString().padStart(2, '0')}:${formData.minute.toString().padStart(2, '0')}`,
      updateMeridiem: formData?.period,
      updateMessage: formData?.updateMessage,
      randomizeDelivery: formData?.randomizeDelivery,
      // NEW:
      shareProgress: formData?.shareProgress,
      progressToShare: formData?.progressToShare
    };
    try {
      const response = isEditing ? await APIServices.put(endpoint, payload) : await APIServices.post(endpoint, payload);
      console.log(response);
      if (response.message) {
        setCurrentTab(4);
        setCompletedTabs((prev) => ({
          ...prev,
          [4]: true
        }));
        setEditing(true);
      } else {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
      // console.log(payload);
    } catch (error) {
      setError(error.message);
    } finally {
      submissionInProgressRef.current = false;
      setLoading(false);
    }
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="tabCover-container">
      <div className="updates-tab">
        {pageLoading ? (
          <div className="nodata-loader">{selectLoader(70)}</div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-12">
                <div className={`update-days-card ${daysError ? 'form-invalid' : ''} ${isSetting ? 'p-0' : ''}`}>
                  {!isSetting && (
                    <div className="row">
                      <div className="col-md-12 col-lg-12">
                        <div className="update-switch">
                          <h4>Auto Updates</h4>
                          <div className="form-switch">
                            <input
                              type="checkbox"
                              name="isInternalProject"
                              id="projectdelay"
                              className="cursor_pointer"
                              checked={formData?.autoUpdate}
                              onChange={toggleAutoUpdate}
                            />
                            <label className="switch cursor_pointer" htmlFor="projectdelay"></label>
                          </div>
                        </div>
                      </div>
                      {/* <div className='col-md-6 col-lg-6'>
                      <div className="update-switch">
                        {!isSetting && (
                          <>
                            {' '}
                            <h4>Internal Project</h4>
                            <div className="form-switch">
                              <input
                                type="checkbox"
                                name="isInternalProject"
                                id="projectdelay"
                                className="cursor_pointer"
                                checked={formData?.autoUpdate}
                                onChange={toggleAutoUpdate}
                              />
                              <label className="switch cursor_pointer" htmlFor="projectdelay"></label>
                            </div>
                          </>
                        )}
                      </div>
                    </div> */}
                    </div>
                  )}
                  <div className={`${isSetting ? 'settings-scheduler' : ''}`}>
                    <div className={`row ${isSetting ? 'w-100' : ''}`}>
                      <div className="col-lg-6 col-md-6">
                        <div className="project-status-cover">
                          {!isSetting && <h3 className="project-status-title">Select Update Days</h3>}
                          <div className="week-container">
                            {daysArray.map(({ index, id, value }) => (
                              <div
                                key={index}
                                className={`day ${formData.selectedDays.includes(value) ? 'selected' : ''}`}
                                onClick={() => toggleDay(value)}>
                                {id}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="select-update-time">
                          <p> {!isSetting && 'Select'} Update Time</p>
                          <div className="time-control">
                            {/* Hour */}
                            <div className="segment">
                              <div className="arrow" onClick={() => changeHour(true)}>
                                <img src={timeUp} alt="increase hour" className="timeUp" />
                              </div>
                              <div className="value" onClick={() => setEditingTimeField('hour')}>
                                {editingTimeField === 'hour' ? (
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={formData.hour}
                                    onChange={(e) => {
                                      const val = e.target.value;

                                      // Allow empty while typing
                                      if (val === '') {
                                        handleChange('hour', '');
                                        return;
                                      }

                                      // Allow only digits & max 2 chars
                                      if (!/^\d{0,2}$/.test(val)) return;

                                      const num = Number(val);

                                      // Prevent typing > 12
                                      if (num > 12) return;

                                      handleChange('hour', val);
                                    }}
                                    onBlur={() => {
                                      let h = Number(formData.hour);
                                      if (!h || h < 1) h = 1;
                                      if (h > 12) h = 12;
                                      handleChange('hour', h);
                                      setEditingTimeField(null);
                                    }}
                                    onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}
                                    autoFocus
                                    className="time-input"
                                  />
                                ) : (
                                  formData.hour.toString().padStart(2, '0')
                                )}
                              </div>
                              <div className="arrow" onClick={() => changeHour(false)}>
                                <img src={timeDown} alt="decrease hour" className="timeDown" />
                              </div>
                            </div>

                            <div className="colon">:</div>

                            {/* Minute */}
                            <div className="segment">
                              <div className="arrow" onClick={() => changeMinute(true)}>
                                <img src={timeUp} alt="increase minute" className="timeUp" />
                              </div>
                              <div className="value" onClick={() => setEditingTimeField('minute')}>
                                {editingTimeField === 'minute' ? (
                                  <input
                                    type="number"
                                    value={formData.minute}
                                    min={0}
                                    max={59}
                                    maxLength={2}
                                    onChange={(e) => {
                                      console.log(e.target.value.length);
                                      handleChange('minute', Math.min(59, Math.max(0, parseInt(e.target.value || 0))));
                                    }}
                                    onBlur={() => setEditingTimeField(null)}
                                    onKeyDown={(e) => e.key === 'Enter' && setEditingTimeField(null)}
                                    autoFocus
                                    className="time-input"
                                  />
                                ) : (
                                  formData.minute.toString().padStart(2, '0')
                                )}
                              </div>
                              <div className="arrow" onClick={() => changeMinute(false)}>
                                <img src={timeDown} alt="decrease minute" className="timeDown" />
                              </div>
                            </div>

                            {/* AM/PM */}
                            <div className="segment">
                              <div className="arrow" onClick={togglePeriod}>
                                <img src={timeUp} alt="toggle period" className="timeUp" />
                              </div>
                              <div className="value">{formData.period}</div>
                              <div className="arrow" onClick={togglePeriod}>
                                <img src={timeDown} alt="toggle period" className="timeDown" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {!isSetting && (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="delivery-box-cover">
                            <div className="update-switch delivery-time">
                              <div className="delivery-time-content">
                                <h4>Randomize Delivery Time</h4>
                                <p>
                                  Vary the delivery time slightly for each order to simulate realistic or unpredictable
                                  delivery patterns.
                                </p>
                              </div>

                              <div className="form-switch">
                                <input
                                  type="checkbox"
                                  name="randomizeDelivery"
                                  id="randomizeDelivery"
                                  className="cursor_pointer"
                                  checked={formData?.randomizeDelivery}
                                  onChange={() =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      randomizeDelivery: !prev.randomizeDelivery
                                    }))
                                  }
                                />
                                <label className="switch cursor_pointer" htmlFor="randomizeDelivery"></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!isSetting && (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="delivery-box-cover">
                            <div className="update-switch delivery-time">
                              <div className="delivery-time-content">
                                <h4>Share Progress</h4>
                                <p>
                                  Pick the progress your client will see on the schedule above. We’ll summarize changes
                                  for the items you check.
                                </p>
                              </div>

                              <div className="form-switch">
                                <input
                                  type="checkbox"
                                  name="shareProgress"
                                  id="shareProgress"
                                  className="cursor_pointer"
                                  checked={!!formData?.shareProgress}
                                  onChange={toggleShareProgress}
                                />
                                <label className="switch cursor_pointer" htmlFor="shareProgress"></label>
                              </div>
                            </div>

                            <div className="shareProgress-list">
                              {/* Milestones */}
                              <div class="shareProgress-checkbox-cover">
                                <label class="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    id="milestones"
                                    checked={formData.progressToShare.milestones === 'summary'}
                                    onChange={(e) =>
                                      setProgressLevel('milestones', e.target.checked ? 'summary' : 'none')
                                    }
                                  />
                                  <span class="checkmark"></span>
                                </label>
                                <p> Milestones</p>
                              </div>

                              {/*tasks  */}
                              <div class="shareProgress-checkbox-cover">
                                <label class="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    id="tasks"
                                    checked={formData.progressToShare.tasks === 'summary'}
                                    onChange={(e) => setProgressLevel('tasks', e.target.checked ? 'summary' : 'none')}
                                  />
                                  <span class="checkmark"></span>
                                </label>
                                <p> Tasks</p>
                              </div>

                              {/* Sub Tasks */}
                              <div class="shareProgress-checkbox-cover">
                                <label class="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    id="subtasks"
                                    checked={formData.progressToShare.subtasks === 'summary'}
                                    onChange={(e) =>
                                      setProgressLevel('subtasks', e.target.checked ? 'summary' : 'none')
                                    }
                                  />
                                  <span class="checkmark"></span>
                                </label>
                                <p> Sub Tasks</p>
                              </div>

                              {/* Checklist Items */}
                              <div class="shareProgress-checkbox-cover">
                                <label class="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    id="checklistItems"
                                    checked={formData.progressToShare.checklistItems === 'summary'}
                                    onChange={(e) =>
                                      setProgressLevel('checklistItems', e.target.checked ? 'summary' : 'none')
                                    }
                                  />
                                  <span class="checkmark"></span>
                                </label>
                                <p>Checklist Items</p>
                              </div>

                              {/* <table className="table">
                       
                       <tr>
                          <td className="pl-0 text-left width-150">
                          <span className="p-0">Milestones</span>
                          </td>
                          <td className="text-end">
                          <input
                              type="checkbox"
                              id="milestones"
                              className="summary-checks"
                              checked={formData.progressToShare.milestones === 'summary'}
                              onChange={(e) => setProgressLevel('milestones', e.target.checked ? 'summary' : 'none')}
                              
                            />
                          </td>
                        </tr>
                        
                        
                        <tr>
                        <td className="pl-0 text-left width-150">
                        <span className="p-0">Tasks</span>
                          </td>
                          <td className="text-end">
                          <input
                          type="checkbox"
                          id="tasks"
                          className="summary-checks"
                          checked={formData.progressToShare.tasks === 'summary'}
                          onChange={(e) => setProgressLevel('tasks', e.target.checked ? 'summary' : 'none')}
                          
                            />
                            </td>
                            </tr>
                            
                            
                            <tr>
                            <td className="pl-0 text-left width-150">
                            <span className="p-0">Sub Tasks</span>
                            </td>
                            <td className="text-end">
                            <input
                              type="checkbox"
                              id="subtasks"
                              className="summary-checks"
                              checked={formData.progressToShare.subtasks === 'summary'}
                              onChange={(e) => setProgressLevel('subtasks', e.target.checked ? 'summary' : 'none')}
                              
                            />
                          </td>
                        </tr>

                        
                        <tr>
                          <td className="pl-0 text-left width-150">
                            <span className="p-0">Checklist Items</span>
                          </td>
                          <td className="text-end">
                            <input
                              type="checkbox"
                              id="checklistItems"
                              className="summary-checks"
                              checked={formData.progressToShare.checklistItems === 'summary'}
                              onChange={(e) =>
                                setProgressLevel('checklistItems', e.target.checked ? 'summary' : 'none')
                              }
                              
                              />
                          </td>
                        </tr>
                        </table> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!isSetting && (
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="head-title-text">Description</div>
                          <div className="input-group mb-0">
                            <ReactQuill
                              value={formData.updateMessage}
                              onChange={(value) => handleChange('updateMessage', value)}
                              placeholder="Write Details"
                              className="form-control br-10 mb-2 p-3"
                              style={{
                                maxHeight: '285px',
                                minHeight: '100px',
                                height: 'auto'
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {daysError && <div className="error-message">{daysError}</div>}
              </div>
              {/* <div className="col-lg-12 mt-3">
                <ReactQuill
                  value={formData.updateMessage}
                  onChange={(value) => handleChange('updateMessage', value)}
                  placeholder="Write Details"
                  className="form-control br-10 mb-2 p-3"
                  style={{
                    maxHeight: '285px',
                    minHeight: '100px',
                    height: 'auto'
                  }}
                />
              </div> */}
            </div>
          </form>
        )}
      </div>
      {/* Submit Button */}
      {!isSetting && (
        <div className="btn-black-cover mb-2">
          <button
            className="btn-black"
            type="submit"
            onClick={handleSubmit}
            disabled={isUpdatesBusy}
            aria-busy={isUpdatesBusy}>
            {!isUpdatesBusy ? (isEditing ? 'Update' : 'Continue') : selectLoader(20)}
            {!isUpdatesBusy && <img src={rightArrowIcon} alt="comp1" className="rightArrowIcon-arrow" />}
          </button>
        </div>
      )}
    </div>
  );
};

export default UpdatesTab;
